"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NACKLE_PAPER_PREFIX = void 0;
exports.NACKLE_PAPER_PREFIX = 'nkl';
var antd_1 = require("antd");
// This function is identical to one defined inside of Ant Design,
// except it returns NACKLE_PAPER_PREFIX instead of 'ant'
// @see https://github.com/ant-design/ant-design/blob/master/components/config-provider/context.tsx#L35
/* istanbul ignore next */
function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls)
        return customizePrefixCls;
    return suffixCls ? "".concat(exports.NACKLE_PAPER_PREFIX, "-").concat(suffixCls) : exports.NACKLE_PAPER_PREFIX;
}
// Boo! It's a side effect! Hack antd's context to change the default namespace
antd_1.ConfigProvider.ConfigContext._currentValue.getPrefixCls = getPrefixCls;
// this prefixes messages, notifications, and modals
antd_1.ConfigProvider.config({ prefixCls: exports.NACKLE_PAPER_PREFIX });
//# sourceMappingURL=namespaceHack.js.map